import {
  Box,
  Text,
  ListItem,
  OrderedList,
  UnorderedList
} from "@chakra-ui/react";
import { AssetImage } from "@mi/asset-react";
import { useTranslation } from "react-i18next";
export default function Detail() {
  const fonts = "MiSans, miui, serif";
  const { t } = useTranslation();
  return (
    <Box
      paddingX={{
        base: "24px",
        xxxs: "24px",
        tablet: "72px",
        desktop: "144px"
      }}
      paddingBottom="40px"
      paddingTop="12px"
      fontFamily={fonts}
    >
      <Text size="big">{t("device.title")}</Text>
      <Box>
        <Text size="md" marginTop="48px" marginBottom="12px">
          {t("device.sub1.title")}
        </Text>
        <Text size="content">{t("device.sub1.content")}</Text>
      </Box>
      <Box>
        <Text size="md" marginTop="48px" marginBottom="12px">
          {t("device.sub2.title")}
        </Text>
        <Text size="content">{t("device.sub2.content")}</Text>
      </Box>
      <Box>
        <Text size="md" marginTop="48px" marginBottom="12px">
          {t("device.sub3.title")}
        </Text>
        <Text size="content">{t("device.sub3.content1")}</Text>
        <Text size="small" marginTop="12px">
          {t("device.sub3.question")}
        </Text>
        <Text size="content">{t("device.sub3.desc")}</Text>
        <Text size="small">{t("device.sub3.detail1")}</Text>
        <UnorderedList>
          {[1, 2, 3, 4, 5, 6, 7, 8].map(num => (
            <ListItem key={num}>
              <Text size="content">{t(`device.sub3.list${num}`)}</Text>
            </ListItem>
          ))}
        </UnorderedList>
        <Text size="small">{t("device.sub3.detail2")}</Text>
        <UnorderedList>
          {[9, 10, 11, 12].map(num => (
            <ListItem key={num}>
              <Text size="content">{t(`device.sub3.list${num}`)}</Text>
            </ListItem>
          ))}
        </UnorderedList>
      </Box>
      <Box>
        <Text size="md" marginTop="48px" marginBottom="12px">
          {t("device.sub4.title")}
        </Text>
        <Text size="small">{t("device.sub4.subTitle1")}</Text>
        <UnorderedList>
          {[1, 2, 3, 4, 5].map(num => (
            <ListItem key={num}>
              <Text size="content">{t(`device.sub4.list${num}`)}</Text>
            </ListItem>
          ))}
        </UnorderedList>
        <Text size="content" paddingBottom="30px">
          {t("device.sub4.desc")}
        </Text>
      </Box>
      {/* <Box>
        <Text size="md" marginTop="48px" marginBottom="12px">
          {t("device.sub5.title")}
        </Text>
        <Text size="content">{t("device.sub5.content1")}</Text>
        <Box
          display="flex"
          justifyContent="left"
          // bg="#F5F5F5"
          border="0px"
          borderRadius="16px"
          margin="12px auto"
        >
          <Box width="180px">
            <AssetImage
              path="battery-detail/alarm.png"
              layout="intrinsic"
              width={392}
              height={912}
              placeholder="data:image/png;base64,UklGRj4AAABXRUJQVlA4IDIAAACwAgCdASoIABQAPtFUo0uoJKMhsAgBABoJaQAAeyAA/vDFlPSWVtv4rNHQ3nZovpGAAA=="
            />
          </Box>
        </Box>
        <Text size="content" marginTop="12px" paddingBottom="30px">
          {t("device.sub5.content2")}
        </Text>
      </Box> */}
    </Box>
  );
}
